module.exports = __webpack_public_path__ + "media/images/icons/mascot/4-dbdd657320dd0898dd2eacae371bda76.png";